/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submitted_ByInputs */

const en_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted By`)
};

const fr_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumis par`)
};

const de_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingereicht von`)
};

const it_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviato da`)
};

const ru_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прислано`)
};

const es_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado por`)
};

const zh_cn2_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交人`)
};

const ja_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提出者`)
};

const hi_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द्वारा प्रस्तुत`)
};

const pt_pt2_submitted_by = /** @type {(inputs: Submitted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado por`)
};

/**
* | output |
* | --- |
* | "Submitted By" |
*
* @param {Submitted_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submitted_by = /** @type {((inputs?: Submitted_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submitted_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_submitted_by(inputs)
	if (locale === "de") return de_submitted_by(inputs)
	if (locale === "it") return it_submitted_by(inputs)
	if (locale === "ru") return ru_submitted_by(inputs)
	if (locale === "es") return es_submitted_by(inputs)
	if (locale === "zh-CN") return zh_cn2_submitted_by(inputs)
	if (locale === "ja") return ja_submitted_by(inputs)
	if (locale === "hi") return hi_submitted_by(inputs)
	if (locale === "pt-PT") return pt_pt2_submitted_by(inputs)
	return en_submitted_by(inputs)
});